module.exports = __webpack_public_path__ + "static/media/cloud-drizzle.46fc185e.svg";